import { useEffect, useState } from "react";
import type { Member } from "../types";

const initialsFor = (name?: string) => (name || "BNI Member").split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join("");

export function MemberPhoto({ member, className = "mini-avatar", eager = false }: { member?: Pick<Member, "fullName" | "photoUrl">; className?: string; eager?: boolean }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [member?.photoUrl]);
  const showPhoto = Boolean(member?.photoUrl && !failed);
  return <span className={`${className} member-photo-frame`} title={member?.fullName} aria-hidden="true">
    {showPhoto ? <img src={member!.photoUrl} alt="" loading={eager ? "eager" : "lazy"} decoding="async" onError={() => setFailed(true)} /> : initialsFor(member?.fullName)}
  </span>;
}
